import { render } from "./ProviderReferralRecordOverlay.vue?vue&type=template&id=05c7f221&scoped=true&lang=pug"
import script from "./ProviderReferralRecordOverlay.vue?vue&type=script&lang=js"
export * from "./ProviderReferralRecordOverlay.vue?vue&type=script&lang=js"

import "./ProviderReferralRecordOverlay.vue?vue&type=style&index=0&id=05c7f221&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c7f221"]])

export default __exports__